import { useStyles } from './useStyles';
import { Typography } from '@mui/material';
import CuminPolicies from '@components/CuminPolicies';
import Header from '@components/Header';
import Footer from '@components/Footer';
import JoinForMeal from '@components/JoinForMeal';

interface IPolicyTypeProps {
  data: any;
  type: string;
}

const PolicyType = (props: IPolicyTypeProps) => {
  const { data, type } = props;
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Header />
      <div className={classes.heading}>
        <Typography variant="h1" color="cinnamon.main" align="center">
          {type}
        </Typography>
      </div>
      <CuminPolicies data={data} type={type} />
      <JoinForMeal />
      <Footer />
    </div>
  );
};

export default PolicyType;
